import React from 'react'
import BodyText from '../Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'

interface Props extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  label?: React.ReactNode;
  expanded?: boolean;
}

function RadioGroup(props: Props) {
  const { label, expanded, children, ...rest } = props

  return (
    <VerticalSpacer {...rest} as="fieldset" gap={16}>
      {label && <BodyText variant="medium" as="legend" weight="bold">{label}</BodyText>}
      <Group direction="vertical" gap={expanded ? 16 : 8}>
        {children}
      </Group>
    </VerticalSpacer>
  )
}

export default RadioGroup
